module.exports = __webpack_public_path__ + "img/plan-people.e7d44b78.png";